module.exports = __webpack_public_path__ + "static/img/bannerNew4.15f6422.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/bannerNew4.webp
// module id = pyFr
// module chunks = 1